import { RessortModuleEntry } from "../helper/interfaces";
import React, { useState, useEffect } from "react";

interface Data {
  module: RessortModuleEntry;
  search: any;
}

function SearchModule(data: Data) {
  const [searchFilter, setSearchFilter] = useState<{ value: string; param: string }[]>([]);
  const [inputId, setInputId] = useState<string>();
  const [inputValue, setInputValue] = useState<string>();

  useEffect(() => {
    data.search(undefined)
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  
  const doSearch = () => {
    let abc = {}
    searchFilter.forEach((element: { param: string; value: string }) => {
      if(!abc[element.param]) {
        abc[element.param] = []
      }
      abc[element.param].push(element.value)
    });

    if(inputId) {
      abc[inputId] = []
      if(inputValue) {
        abc[inputId].push(inputValue)
      }
    }

    Object.keys(abc).forEach(key => {
      abc[key] = abc[key].join(",")
    })
  
    data.search(abc)
  }

  const addModuleSearchFilter = (value: string, param: string) => {
    const entry = searchFilter.find((x: { value: string; param: string }) => x.value == value && x.param == param)
    if(!entry) {
      const newSearchFilter = [...searchFilter, {value, param}]
      setSearchFilter(newSearchFilter)
    }
  }

  const removeModuleSearchFilter = (value: string, param: string) => {    
    setSearchFilter(searchFilter.filter(x => x.value != value || x.param != param))
  }

  function handleInputChange(id, value) {
    setInputId(id)
    setInputValue(value)
  }
  
  return (
    <React.Fragment key={`module-search-${data.module.id}`}>
      <div className="searchbox">
        <h2 className="searchbox_title headline--h2">{data.module.title}</h2>

        {data.module.searchModuleOptions && data.module.searchModuleOptions.length > 0 && 
          data.module.searchModuleOptions.map((entry) => {
            return (<React.Fragment key={`module-search-${data.module.id}-${entry.param}`}>
              { entry.type == "input" &&
                <div>
                  <div className="searchbox_module">
                    <input type="text" className="searchfield" placeholder={entry.label} key={`${entry.param}-${module.id}`} onChange={(event) => handleInputChange(entry.param, event.target.value)} />
                    <button className="btn btn-searchbox" onClick={() => doSearch()}>Suche</button>
                  </div>
                  <div className="searchbox_filter">
                    {searchFilter.map((m) => {return <span key={`filter-${entry.param}-${module.id}-${m.value}-${m.param}`} onClick={(e) => {removeModuleSearchFilter(m.value, m.param);}}>{m.value}</span>})}
                  </div>
                </div>
              }
            </React.Fragment>)
          })
        }
        <div className="searchbox_filterbox">
          {data.module.searchModuleOptions && data.module.searchModuleOptions.length > 0 && 
            data.module.searchModuleOptions.map((entry) => {
              return (<React.Fragment key={`module-search-${data.module.id}-${entry.param}`}>
              
                  { entry.type == "select" &&
                    <div className="dropdown" key={`${entry.param}-${module.id}`}>
                      <select key={`select-${entry.param}-${module.id}`} name={entry.label} onChange={(e) => {addModuleSearchFilter(e.target.value, entry.param);}}>
                        <option value={entry.label}>{entry.label}</option>
                        {
                          entry.values?.map((v) => {
                            return (<option value={v} key={`option-${entry.param}-${module.id}-${v}`}>{v}</option>)
                          })
                        }
                      </select>
                    </div>
                  }
              </React.Fragment>)
            })
          }
        </div>
      </div>
  </React.Fragment>)
}

export default SearchModule;
